import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_11 = { class: "admin-search-box" }
const _hoisted_12 = { class: "admin-add-btn" }
const _hoisted_13 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_14 = { class: "tags" }
const _hoisted_15 = { class: "delete-all-btn-link" }
const _hoisted_16 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_17 = { class: "add-banner-image-section" }
const _hoisted_18 = { class: "add-banner-image-box" }
const _hoisted_19 = { class: "admin-input-field" }
const _hoisted_20 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_21 = { class: "admin-input-field" }
const _hoisted_22 = { class: "admin-input-field-submit" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_25 = { class: "admin-item-list-section-scroll" }
const _hoisted_26 = { class: "admin-item-list-top" }
const _hoisted_27 = { class: "admin-item-list-row" }
const _hoisted_28 = { class: "admin-item-checkbox" }
const _hoisted_29 = { class: "admin-checkbox-input" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = { class: "admin-item-jobs-category-active-inactive" }
const _hoisted_32 = { class: "admin-item-sm-actions" }
const _hoisted_33 = { class: "admin-item-list-btm" }
const _hoisted_34 = { ref: "sortableList" }
const _hoisted_35 = { class: "admin-item-box-top" }
const _hoisted_36 = { class: "admin-item-list-row" }
const _hoisted_37 = { class: "admin-item-checkbox" }
const _hoisted_38 = { class: "admin-checkbox-input" }
const _hoisted_39 = ["id", "onChange", "checked"]
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "admin-item-jobs-category-title" }
const _hoisted_42 = { class: "admin-item-jobs-category-active-inactive" }
const _hoisted_43 = { class: "category-active-inactive-img" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["name", "onUpdate:modelValue"]
const _hoisted_46 = ["name", "onUpdate:modelValue"]
const _hoisted_47 = { class: "admin-item-sm-actions" }
const _hoisted_48 = { class: "admin-action-link" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_52 = { class: "add-banner-image-section" }
const _hoisted_53 = { class: "add-banner-image-box" }
const _hoisted_54 = { class: "admin-input-field" }
const _hoisted_55 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_56 = { class: "admin-input-field" }
const _hoisted_57 = { class: "admin-input-field-submit" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "admin-pagination-section" }
const _hoisted_60 = { class: "custom-row" }
const _hoisted_61 = { class: "item-show-selectbox" }
const _hoisted_62 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { class: "admin-site-footer" }
const _hoisted_66 = { class: "container" }
const _hoisted_67 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_68 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = { class: "confirmation-popup-mid" }
const _hoisted_71 = { class: "confirmation-popup-btm" }
const _hoisted_72 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_BLOG_CATEGORIES_TEXT) + " (" + _toDisplayString(_ctx.counts) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachBlogCgInput",
                        type: "text",
                        placeholder: "Search Categories",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.fetchBlogCategories(_ctx.limit, _ctx.skip), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        id: "addBlogCgBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddBlogCategoryForm && _ctx.openAddBlogCategoryForm(...args)))
                      }, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_BLOG_CATEGORY_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedBlogCategories.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedBlogCategories.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedBlogCategories = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_BLOG_TEXT), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("form", {
                        id: "addBlogForm",
                        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.CATEGORY_TITAL_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "blogCgTitleInput",
                            type: "text",
                            placeholder: "Enter the Title",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newBlogCategorie.title) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newBlogCategorie.title]
                          ]),
                          (!_ctx.newBlogCategorie.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "active-inactive-radio",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleStatus(false)))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              id: "yesRadioInput",
                              name: "foo",
                              class: "active-radio",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newBlogCategorie.status) = $event)),
                              value: 1
                            }, null, 512), [
                              [_vModelRadio, _ctx.newBlogCategorie.status]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              id: "noRadioInput",
                              name: "foo",
                              class: "inactive-radio",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newBlogCategorie.status) = $event)),
                              value: 0
                            }, null, 512), [
                              [_vModelRadio, _ctx.newBlogCategorie.status]
                            ]),
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "admin-btn-outline-primary add-new-cancel",
                            id: "submitBtn",
                            type: "submit",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_23),
                          _createElementVNode("button", {
                            class: "admin-btn-outline-secondary add-new-cancel",
                            id: "cancelBtn",
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editBlogCategoriesData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section admin-jobs-category-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_30),
                              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-jobs-category-title",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editBlogCategoriesData, (blogCategorie, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: blogCategorie.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': blogCategorie.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + blogCategorie.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleBlogCategorieSelection(blogCategorie.id)),
                                        checked: _ctx.selectedBlogCategories.includes(blogCategorie.id)
                                      }, null, 40, _hoisted_39),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + blogCategorie.id
                                      }, null, 8, _hoisted_40)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(blogCategorie.title), 1),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", {
                                        class: "active-inactive-radio",
                                        onClick: ($event: any) => (
                                    _ctx.changeBlogCategorieStatus(blogCategorie.id, blogCategorie.status)
                                  )
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "radio",
                                          id: "ActiveInput",
                                          name: 'status_' + blogCategorie.id,
                                          class: "active-radio",
                                          "onUpdate:modelValue": ($event: any) => ((blogCategorie.status) = $event),
                                          value: 1
                                        }, null, 8, _hoisted_45), [
                                          [_vModelRadio, blogCategorie.status]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "radio",
                                          id: "InActiveInput",
                                          name: 'status_' + blogCategorie.id,
                                          class: "inactive-radio",
                                          "onUpdate:modelValue": ($event: any) => ((blogCategorie.status) = $event),
                                          value: 0
                                        }, null, 8, _hoisted_46), [
                                          [_vModelRadio, blogCategorie.status]
                                        ]),
                                        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                                      ], 8, _hoisted_44)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("ul", _hoisted_48, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "blgCgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editBlogCategorie(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_49)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          "data-bs-toggle": "modal",
                                          id: "blogCgDeleteBtn",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', blogCategorie.id), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_50)
                                      ])
                                    ])
                                  ]),
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "clear" }, null, -1))
                                ])
                              ]),
                              (blogCategorie.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_BLOG_CATEGORIES_TEXT), 1),
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.CATEGORY_TITAL_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "blogCgTitleInput",
                                            type: "text",
                                            placeholder: "Enter the Title",
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editBlogCategorieData.title) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editBlogCategorieData.title]
                                          ]),
                                          (!_ctx.editBlogCategorieData.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.ACTIVE_INACTIVE_LABEL), 1),
                                          _createElementVNode("div", {
                                            class: "active-inactive-radio",
                                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleStatus(true)))
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              id: "yesRadioInput",
                                              type: "radio",
                                              name: "foo",
                                              class: "active-radio",
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editBlogCategorieData.status) = $event)),
                                              value: 1
                                            }, null, 512), [
                                              [_vModelRadio, _ctx.editBlogCategorieData.status]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              id: "noRadioInput",
                                              type: "radio",
                                              name: "foo",
                                              class: "inactive-radio",
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editBlogCategorieData.status) = $event)),
                                              value: 0
                                            }, null, 512), [
                                              [_vModelRadio, _ctx.editBlogCategorieData.status]
                                            ]),
                                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "active-inactive-radio-img" }, null, -1))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-primary addNewCancel",
                                            id: "submitBtn",
                                            onClick: ($event: any) => (_ctx.submitEditForm(blogCategorie.id))
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_58),
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            id: "cancelBtn",
                                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_63))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("button", _hoisted_72, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}